import { apiGet } from '../support/helpers/ApiConnection.Helper';
import ProfileEntity from '../entities/Profile.Entity';

export default function getProfiles(abortSignal: AbortSignal): Promise<Array<ProfileEntity>> {
    return apiGet<Array<ProfileEntity>>('/profiles', abortSignal);
}